<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="3"
            xl="2"
          >
            <b-form-group
              label="Ano"
              label-for="filter-year"
            >
              <v-select
                v-model="filterYear"
                :options="yearOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="filter-year"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="4"
            xl="2"
          >
            <b-form-group
              label="Mês"
              label-for="filter-month"
            >
              <v-select
                v-model="filterMonth"
                :options="monthOptions"
                :reduce="val => val.value"
                :clearable="false"
                input-id="filter-month"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="5"
            xl="4"
          >
            <label for="institution-id">Instituição</label>
            <v-select
              id="institution-id"
              v-model="institutionId"
              name="institution-id"
              :options="institutionOptions"
              label="label"
              item-value="value"
              item-text="label"
            >
              <span slot="no-options">Nenhuma instituição encontrada.</span>
            </v-select>
          </b-col>
          <b-col
            cols="12"
            md="8"
            xl="4"
          >
            <label class="invisible d-none d-md-block">Ações</label>
            <div class="d-flex justify-content-end">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="btn-icon mr-1"
                @click="loadReport"
              >
                Buscar
                <feather-icon
                  icon="SearchIcon"
                  size="16"
                />
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="btn-icon"
                @click="downloadReport"
              >
                Exportar
                <feather-icon
                  icon="DownloadIcon"
                  size="16"
                />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-card>

    <b-card
      no-body
      class="mt-2 mb-0"
    >
      <b-table
        class="position-relative"
        :items="items"
        :busy="loading"
        responsive
        sticky-header="900px"
        :fields="tableColumns"
        primary-key="workplace_id"
        show-empty
        empty-text="Nenhum registro encontrado"
      >
        <template #cell(workplace_name)="{ item }">
          <div :title="item.workplace_name">
            {{ truncateString(item.workplace_name, 30) }}
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import store from '@/store'
import Ripple from 'vue-ripple-directive'
import { onUnmounted } from '@vue/composition-api'
import vSelect from 'vue-select'
import {
  BCard, BRow, BCol, BFormGroup, BButton, BTable,
} from 'bootstrap-vue'
import reportStoreModule from '../../reportStoreModule'
import useMonthlyWorkplaceReport from './useMonthlyWorkplaceReport'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BButton,
    BTable,
    vSelect,
  },
  setup() {
    const REPORTS_STORE_MODULE_NAME = 'app-reports'
    if (!store.hasModule(REPORTS_STORE_MODULE_NAME)) store.registerModule(REPORTS_STORE_MODULE_NAME, reportStoreModule)

    onUnmounted(() => {
      if (store.hasModule(REPORTS_STORE_MODULE_NAME)) store.unregisterModule(REPORTS_STORE_MODULE_NAME)
    })

    const {
      loading,
      filterYear,
      filterMonth,
      yearOptions,
      monthOptions,
      institutionId,
      institutionOptions,
      fetchInstitutions,
      items,
      tableColumns,
      loadReport,
      downloadReport,
      truncateString,
    } = useMonthlyWorkplaceReport()

    fetchInstitutions()
    loadReport()

    return {
      loading,
      filterYear,
      filterMonth,
      yearOptions,
      monthOptions,
      institutionId,
      institutionOptions,
      items,
      tableColumns,
      loadReport,
      downloadReport,
      truncateString,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

label {
  margin-top: 0.2857rem!important;
}
</style>
